<template>
  <div class="container">
    <div class="linkTitle">
      <div :class="['headerContent']">
        <div>
          <span @click="toHomePage" class="home textHover">
            <i class="el-icon-s-home iconRed"></i
            ><span :style="{ color: '#f40' }">首页</span>
          </span>
          <!-- <span class='address marginV'>北京</span> -->
          <el-dropdown placement="bottom-start">
            <span class="marginV" v-if="userInfo">
              Hi&nbsp;,&nbsp;
              <span class="textHover">{{ userInfo.nickName }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <div v-if="userInfo">
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownBox">
                  <div class="dropdownBoxTitle">
                    <span @click="toSettingPage" class="manage textHover">账号管理</span>
                    <span class="slice">|</span>
                    <span @click="loginOut" class="loginOut textHover"
                      >退出</span
                    >
                  </div>
                  <div class="dropdownBoxContent">
                    <div class="headImgBox">
                      <el-image
                        :src="getImageUrl(userInfo.headImg)"
                        fit="cover"
                      ></el-image>
                    </div>
                    <div class="dropdownBoxContentRight">
                      {{ userInfo.telephone }}
                    </div>
                  </div>
                </div>
              </el-dropdown-menu>
            </div>
          </el-dropdown>
          <span @click="loginOut" class="textHover marginV" v-if="userInfo"
            >退出</span
          >
        </div>
        <div class="headerTextWrap">
          <span v-if="!userInfo" class="login textHover" @click="login"
            >您好,请登录</span
          >
          <span v-if="!userInfo" class="textHover" @click="register"
            >免费注册</span
          >

          <span class="sliceIcon" v-if="!userInfo">|</span>
          <span class="textHover" @click="myOrder">我的订单</span>
          <span class="sliceIcon">|</span>
          <!-- <span class="textHover" @click="industryInformation">行业资讯</span>
        <span class="sliceIcon">|</span> -->
          <span class="textHover" @click="publishMessage">发布信息</span>
          <span class="sliceIcon">|</span>

          <span class="textHover" @click="myShoppingCart">
            <i class="el-icon-shopping-cart-2 iconRed"></i>
            我的购物车
            <span class="totalNum">{{ totalNum }}</span>
          </span>

          <span class="sliceIcon">|</span>
          <span class="textHover" @click="prepayRecharge">
            <i class="el-icon-s-order"></i>
            预付款</span>
          

          <span class="sliceIcon">|</span>
          <span
            class="textHover"
            v-if="userInfo && userInfo.storeId && busi_flag == 1"
            @click="sellerCenter"
            >卖家中心</span
          >
          
          <span
            class="sliceIcon"
            v-if="userInfo && userInfo.storeId && busi_flag == 1"
            >|</span
          >
          <span class="textHover" @click="companyJoinUs">商家入驻</span>
          <span class="sliceIcon">|</span>
          <span
            class="textHover"
            @click="toSettingPage"
            >账号管理</span
          >
          <!-- <span class="sliceIcon">|</span>
          <el-popover
            placement="bottom"
            title="扫描二维码下载"
            width="150"
            trigger="hover"
            content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
          >
            <img class='qrcode' src="../../../../static/qrcode.png" alt="">
            <el-button type='text' slot="reference"><i class="el-icon-mobile-phone iconRed"></i>手机肉联所</el-button>
          </el-popover> -->
        </div>
      </div>
    </div>
    <div :style="{ height: '36px' }"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getImageUrl, queryCompanyGetUrl } from "@/api/api";
export default {
  created() {
    this.getImageUrl = getImageUrl;
  },
  props: {
    propsStyle: {
      type: [Object],
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      a: "linkTitle",
      busi_flag: 0,
    };
  },

  computed: {
    ...mapState(["cartList", "userInfo"]),
    totalNum() {
      return this.$getCartInfo(this.cartList).num;
    },
  },
  mounted() {
    console.log(this.userInfo);
    if(this.userInfo){
    let { access_token, storeId } = this.userInfo;
    if (storeId) {
      this.getCompanyMsg(access_token, storeId);
    }
  }
  },
  methods: {
    ...mapMutations(["loginOutClearInfo"]),
    publishMessage() {
      this.$router.push("/publishMessage");
    },
    prepayRecharge(){
      this.$router.push("/prepayRecharge");
    },
    companyJoinUs() {
      if (this.$route.name != "auth") {
        this.$router.push("/auth");
      }
    },
    toHomePage() {
      this.$router.push({ path: "/" });
    },
    login() {
      this.$router.push({ path: "/login" });
    },
    loginOut() {
      this.$loginOut(this.userInfo).then(() => {
        this.loginOutClearInfo();
        this.$router.push("/login");
      });
    },
    register() {
      this.$router.push({ name: "login", query: { isRegister: true } });
    },
    myOrder() {
      // this.$checkLogin(this.userInfo).catch((e)=>{})
      this.$checkLogin(this.userInfo)
        .then(() => {
          console.log(this.$route);
          if (this.$route.name != "myOrder") {
            this.$router.push("/myOrder");
          }
        })
        .catch((e) => {
          this.$router.push({ path: "/login" });
        });
    },
    industryInformation() {
      this.$router.push({ path: "/industryInformation" });
    },
    myShoppingCart() {
      this.$checkLogin(this.userInfo)
        .then(() => {
          console.log(this.$route);
          if (this.$route.name != "cart") {
            this.$router.push({ path: "/cart" });
          }
        })
        .catch((e) => {
          this.$router.push({ path: "/login" });
        });
    },
    sellerCenter() {
      this.$router.push({ path: "/sellCenter/whitebar" });
    },
    toPhone() {},
    toSettingPage() {
      this.$router.push({name:"settingPage"});
    },
    getCompanyMsg(access_token, storeId) {
      let that = this;
      let data = {
        access_token: access_token,
        storeId: storeId,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({ method: "post", data: param, url: queryCompanyGetUrl })
        .then(function (res) {
          console.log("公司信息", res);
          if (res.data.resultCode == 1) {
            console.log(res.data);
            let { data } = res.data;
            let { company } = data;
            console.log(company);
            let { busi_flag } = company;
            console.log(busi_flag);
            that.busi_flag = busi_flag;
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped lang='less'>
@media screen and (min-width: 320px) and (max-width: 1200px) {
  .linkTitle {
    padding: 0 10px 0 !important;
  }
}

.linkTitle {
  background-color: #eee;
  border-bottom: 1px solid #eee;
  padding: 0 150px;
  // min-width: 1000px;
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  z-index: 100;
}
.headerContent {
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  font-size: 13px;
  color: #666;
}
.totalNum {
  color: #f40;
  font-weight: 700;
  font-size: 13px;
}
.login {
  color: #f40;
  margin-right: 2px;
}
.marginV {
  margin: 0 5px;
}
.iconRed {
  color: #f40;
  font-weight: 600;
  margin-right: 2px;
}
.el-icon--right {
  font-size: 10px;
  transform: scale(0.7);
}
.dropdownBox {
  width: 180px;
  height: 70px;
  // background-color: pink;
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
}
.headImgBox {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  overflow: hidden;
  position: relative;
  top: -15px;
}
.dropdownBoxTitle {
  display: flex;
  justify-content: flex-end;
  font-size: 13px;
  // background-color: blue;
  height: 30px;
  align-items: center;
  color: #666;
}
.manage {
}
.manage:hover {
  cursor: pointer;
}
.slice {
  margin: 0 8px;
  color: #ccc;
}
.loginOut {
}
.sliceIcon {
  color: #aaa;
}
.loginOut:hover {
  cursor: pointer;
}
.dropdownBoxContent {
  display: flex;
  align-items: center;
  // background-color: yellow;
  flex: 1;
}
.dropdownBoxContentRight {
  font-size: 13px;
  color: #666;
  margin-left: 30px;
}
.appOfPhone:hover {
}
.qrcode{
  width: 150px;
  height: 150px;
}
.home{
  margin-right: 10px;
}
</style>





// WEBPACK FOOTER //
// src/components/components/LinkTitle/LinkingTitle.vue